<script setup>
defineProps({
  title: String,
  value: [Array, String, Number],
  hideNulls: Boolean,
  arrayAsColumn: Boolean,
  titleClass: Array,
  titleClassWidth: {
    type: String,
    default: 'w-1/3'
  },
  valueClass: Array,
  emptyValue: String
});
</script>

<template>
  <div
    v-if="
      !(
        hideNulls &&
        (value === null || (Array.isArray(value) && value.length === 0))
      )
    "
    class="flex"
  >
    <div :class="titleClass ?? [titleClassWidth, 'font-bold', 'shrink-0']">
      {{ title }}
    </div>
    <div v-if="!Array.isArray(value)" :class="valueClass ?? ['break-all']">
      {{ value ?? emptyValue }}
    </div>
    <div v-else-if="value.length === 0" :class="valueClass ?? ['break-all']">
      {{ emptyValue }}
    </div>
    <div v-else-if="!arrayAsColumn" :class="valueClass ?? ['break-all']">
      {{ value.join(', ') }}
    </div>
    <div v-else class="flex-col">
      <div
        v-for="(v, i) in value"
        :key="i"
        :class="valueClass ?? ['break-all']"
      >
        {{ v }}
      </div>
    </div>
  </div>
</template>
